import { type ReactNode, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { WorkspaceCreationForm } from '../../WorkspaceCreationForm';
import type { WorkspaceCreationFormData } from '../../WorkspaceCreationForm';
import { SuccessContent } from './SuccessContent';
import splitStyles from '@/components/layout/SplitScreenLayout/SplitScreenLayout.module.css';
import styles from '../WorkspaceOnboardingPage.module.css';

interface RightPanelContentProps {
  showCTA: boolean;
  createdWorkspaceName: string;
  onGoToWorkspace: () => void;
  onGoToDashboard: () => void;
  onSubmit: (data: WorkspaceCreationFormData) => Promise<void>;
  isCreating: boolean;
}

export const RightPanelContent = memo(function RightPanelContent({
  showCTA,
  createdWorkspaceName,
  onGoToWorkspace,
  onGoToDashboard,
  onSubmit,
  isCreating,
}: RightPanelContentProps): ReactNode {
  const { t } = useTranslation();

  if (showCTA) {
    return (
      <SuccessContent
        workspaceName={createdWorkspaceName}
        onGoToWorkspace={onGoToWorkspace}
        onGoToDashboard={onGoToDashboard}
        isMobile={false}
      />
    );
  }

  return (
    <div className={styles.rightFormWrapper}>
      <h2
        className={`${styles.formTitle} ${splitStyles.fadeElement} ${splitStyles.fadeDelay2}`}
      >
        {t('workspace.onboarding.form.title')}
      </h2>
      <p
        className={`${styles.formSubtitle} ${splitStyles.fadeElement} ${splitStyles.fadeDelay2}`}
      >
        {t('workspace.onboarding.form.subtitle')}
      </p>
      <WorkspaceCreationForm onSubmit={onSubmit} isSubmitting={isCreating} />
    </div>
  );
});
